<template>
  <div class="container">
    <template v-for="item of list">
      <router-link :key="item.id" tag="section" :to="'/guide/floor/' + item.id">
        <van-image
          width="100%"
          radius="8"
          :src="item.img"
        />
        <p>{{ item.title }}</p>
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({
    list: [
      {
        id: 0,
        title: '山西博物院0',
        img: 'https://w.wallhaven.cc/full/y8/wallhaven-y8v6ox.jpg'
      },
      {
        id: 1,
        title: '山西博物院1',
        img: 'https://w.wallhaven.cc/full/72/wallhaven-72r8ry.jpg'
      },
      {
        id: 2,
        title: '山西博物院2',
        img: 'https://w.wallhaven.cc/full/6o/wallhaven-6owxo6.jpg'
      },
      {
        id: 3,
        title: '山西博物院3',
        img: 'https://w.wallhaven.cc/full/v9/wallhaven-v95lq3.jpg'
      },
      {
        id: 4,
        title: '山西博物院4',
        img: 'https://w.wallhaven.cc/full/72/wallhaven-72r8ry.jpg'
      }
    ]
  })
}
</script>

<style lang="scss" scoped>
  .container {
    background-color:#EFEFEF;
    padding-top: 20px;
    box-sizing: border-box;
    section {
      margin: 0 20px;
      text-align: center;
      color: #7A2405;
      font-size: 24px;
      p {
        margin: 0;
        margin-top: 10px;
        padding-bottom: 20px;
      }
    }
  }
</style>
